import { NibbleAction } from '@aipb/gulliver/personal-content/model';
import { NibbleActionHandler } from '../nibble-action.handler';

export class TxtNibbleActionHandler implements NibbleActionHandler {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handle(nibbleAction: NibbleAction) {}

  getUrl(nibbleAction: NibbleAction): string {
    return nibbleAction.nibbleCut.nibble.userLabel;
  }

  useResolver(): boolean {
    return false;
  }
}
